// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__iS9Km","textContainer":"style_textContainer__ZzYLo"};